import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	weeklyHoliday: null,
	error: "",
	loading: false,
};

// ADD_leavePolicy
export const addSingleWeeklyHoliday = createAsyncThunk(
	"leavePolicy/addSingleWeeklyHoliday",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `leave/WeeklyWorkingDaysSetup`,
				data: {
					...values,
				},
			});
			toast.success("WeeklyHoliday Added");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding WeeklyHoliday try again");
			// console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

export const createDayPartSchedule = createAsyncThunk(
	"leavePolicy/createDayPartSchedule",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `weekly-holiday/createDayPartSchedule`,
				data: {
					...values,
				},
			});
			toast.success("WeeklyHoliday Added");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding WeeklyHoliday try again");
			// console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);


// DELETE_leavePolicy
export const deleteWeeklyHoliday = createAsyncThunk(
	"leavePolicy/deleteWeeklyHoliday ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `weekly-holiday/${id}`,
			});

			toast.success("WeeklyHoliday Deleted");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting WeeklyHoliday try again");
			// console.log(error.message);
		}
	}
);

// leavePolicy_DETAILS
export const loadSingleWeeklyHoliday = createAsyncThunk(
	"leavePolicy/loadSingleWeeklyHoliday",
	async (id) => {
		try {
			const data = await axios.get(`weekly-holiday/${id}`);
			return data;
		} catch (error) {
			// console.log(error.message);
		}
	}
);

// leavePolicyS
export const loadAllWeeklyHoliday = createAsyncThunk(
	"leavePolicy/loadAllWeeklyHoliday",
	async () => {
		try {
			const { data } = await axios.get(`leave/WeeklyWorkingDaysGetByCompanyId`);
			return data;
		} catch (error) {
			// console.log(error.message);
		}
	}
);

export const getDayPartSchedules = createAsyncThunk(
	"weekly-holiday/getDayPartSchedules",
	async () => {
		try {
			const { data } = await axios.get(`weekly-holiday/getDayPartSchedules`);
			return data;
		} catch (error) {
			// console.log(error.message);
		}
	}
);

export const updateWeeklyHoliday = createAsyncThunk(
	"leavePolicy/updateWeeklyHoliday",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `weekly-holiday/${id}`,
				data: {
					...values,
				},
			});
		// 	toast.success(<div>
			
		// 	<ul style={{ margin: "0.5em 0", paddingLeft: "1.2em" }}>
		// 	  {data.map((msg, index) => (
		// 		<li key={index}>{msg}</li>
		// 	  ))}
		// 	</ul>
		//   </div>
		//   )
			toast.success("WeeklyHoliday Updated");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating WeeklyHoliday try again");
			// console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

export const EmployeeWeeklyWorkingDaysHistorySetup = createAsyncThunk(
	"shift/EmployeeWeeklyWorkingDaysHistorySetup",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `employee/EmployeeWeeklyWorkingDaysHistorySetup`,
				data: {
					...values,
				},
			});
			toast.success(
				<div>
					<ul>
						{data.map((day, index) => (
							<li key={index}>{day.message}</li>
						))}
					</ul>
				</div>
			);
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Employment Status try again");
			// console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const weeklyHolidaySlice = createSlice({
	name: "weeklyHoliday",
	initialState,
	reducers: {
		clearWeeklyHoliday: (state) => {
			state.weeklyHoliday = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for loadAllWeeklyHoliday ======

		builder.addCase(loadAllWeeklyHoliday.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadAllWeeklyHoliday.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload ||[];
		});

		builder.addCase(loadAllWeeklyHoliday.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 1) ====== builders for getDayPartSchedules ======

		builder.addCase(getDayPartSchedules.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getDayPartSchedules.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getDayPartSchedules.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
		// 2) ====== builders for addSingleWeeklyHoliday  ======

		builder.addCase(addSingleWeeklyHoliday.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addSingleWeeklyHoliday.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addSingleWeeklyHoliday.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for createDayPartSchedule  ======

		builder.addCase(createDayPartSchedule.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(createDayPartSchedule.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(createDayPartSchedule.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for loadSingleWeeklyHoliday ======

		builder.addCase(loadSingleWeeklyHoliday.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadSingleWeeklyHoliday.fulfilled, (state, action) => {
			state.loading = false;
			state.weeklyHoliday = action.payload.data;
		});

		builder.addCase(loadSingleWeeklyHoliday.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for leavePolicy ======

		builder.addCase(updateWeeklyHoliday.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateWeeklyHoliday.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateWeeklyHoliday.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteWeeklyHoliday  ======

		builder.addCase(deleteWeeklyHoliday.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteWeeklyHoliday.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteWeeklyHoliday.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		builder.addCase(EmployeeWeeklyWorkingDaysHistorySetup.pending, (state) => {
					state.loading = true;
				});
		
				builder.addCase(EmployeeWeeklyWorkingDaysHistorySetup.fulfilled, (state, action) => {
					state.loading = false;
		
					if (!Array.isArray(state.list)) {
						state.list = [];
					}
					const list = [...state.list];
					list.push(action.payload);
					state.list = list;
				});
		
				builder.addCase(EmployeeWeeklyWorkingDaysHistorySetup.rejected, (state, action) => {
					state.loading = false;
					state.error = action.payload.message;
				});
	},
});

export default weeklyHolidaySlice.reducer;
export const { clearWeeklyHoliday } = weeklyHolidaySlice.actions;
